var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.bundleProductSlide = {
    /*
     * This is largely a wrapper around the current BB product_gallery_v1.js
     * which does not use slick.
     */
    init_carousel: function ($carousel, $gallery, prodData) {
      var default_sku = prodData['defaultSku'];
      var slide_class = '.fluid-image';
      var settings = {
        rtl: site.direction.isRTL,
        arrows: false,
        dots: true,
        speed: 300,
        slide: slide_class,
        slidesToShow: 1,
        slidesToScroll: 1
      };

      /*
       * triggered by displaySkuAltImage in product_gallery_v1.js
       */
      $gallery.on('gallery.startMungeImages', function (e, idx) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.unslick();
        }
      });

      /*
       * triggered by displaySkuAltImage in product_gallery_v1.js
       *
       * We run this after displaySkuAltImage which handles generating the
       * image list per sku
       */
      $gallery.on('gallery.mungedImages', function (e, idx) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.unslick();
        }
        // allow settings initial slide. this is one use.
        if (typeof $gallery.data('initial-slide') !== 'undefined') {
          idx = $gallery.data('initial-slide');
          $gallery.removeData('initial-slide'); // one use
        }
        settings['initialSlide'] = idx;
        $carousel.slick(settings);
        $carousel.resize();
      });

      $gallery.on('gallery.selectImage', function (e, idx) {
        $carousel.slickGoTo(idx);
      });

      // we trigger starting image processing. Normally this is only called
      // on skuSelect. We trigger it manually here because we want the image
      // list processing.
      // Note: the initial carousel creation happens on the gallery.mungedImages
      // event.
      $gallery.data('initial-slide', 0);
      Drupal.behaviors.productGalleryV1.displaySkuAltImage($gallery, default_sku['SKU_BASE_ID']);
    },

    attach: function (context, settings) {
      var mod = this;
      var $slides = $('.js-bundle-product-slide', context);

      $slides.each(function (i, obj) {
        var $product_slide = $(obj);
        var $product = prodcat.ui.getProductEl($product_slide);
        var prodData = prodcat.data.getProduct($product.data('product-id'));

        if (!prodData) {
          return;
        }
        var $galleries = $('.js-product-gallery', $product_slide);

        $galleries.each(function (i, obj) {
          var $gallery = $(obj);
          var carousels = $('.js-product-gallery__main', $gallery);

          // render the carousel.
          carousels.each(function (i, obj) {
            var $carousel = $(obj);

            mod.init_carousel($carousel, $gallery, prodData);
          });
        });
      });
    }
  };
})(jQuery);
